import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { AssessmentSingleEntryTemplate } from "app/features/reporting/templates/AssessmentSingleEntryTemplate";
import { useResidentContext } from "app/features/residents/provider/ResidentProvider";

const tag = FormEnums.ADMISSION_CHECKLIST;

export default function ResidentAdmissionChecklistForm() {
  const { resident } = useResidentContext();
  return (
    <AssessmentSingleEntryTemplate
      tag={tag}
      noEntryTitle="Admission Checklist not yet created"
      fillLink={`/residents/${resident?.id}/admission/fill`}
    />
  );
}
